import React from "react";
import { Elements } from "react-stripe-elements";

export default WrappedComponent => ({ ...props }) => (
  <Elements>
    <WrappedComponent {...props} />
  </Elements>
);


// WEBPACK FOOTER //
// ./src/components/StripeElements.js